// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingChatClientes_LinkResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /config/messaging_chat_clientes/link.
 *
 * Returns the newly-created chat_cliente_id so the frontend can reference the
 * link without re-querying.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessagingChatClientes_LinkResponseDados {
chat_cliente_id: number
}

export type MessagingChatClientes_LinkResponse = ApiResponse<MessagingChatClientes_LinkResponseDados>;

registerResponseContract('MessagingChatClientes_LinkResponse', {
  chat_cliente_id: { type: 'number',  required: true },
})
